<template>
  <div class="table-container">
    <table class="table is-fullwidth is-narrow is-hoverable">
      <thead>
        <tr class="is-unselectable">
          <th @click="$emit('order', ['friendlyName', 'name'])">
            Name
          </th>
          <th @click="$emit('order', 'online')">Online</th>
          <th @click="$emit('order', 'onlineChanged')">
            Online Changed
          </th>
          <th @click="$emit('order', 'inventorying')">
            Inventorying
          </th>
          <th @click="$emit('order', 'clientVersion')">
            Agent Version
          </th>
          <th @click="$emit('order', 'systemInfo.systemDiskType')">
            Disk Type
          </th>
          <th @click="$emit('order', 'systemInfo.freeSystemDiskSpace')">
            Free Space
          </th>
          <th @click="$emit('order', 'systemInfo.ramTotal')">RAM</th>
          <th @click="$emit('order', 'systemInfo.osVersion')">
            OS Version
          </th>
          <th @click="$emit('order', 'systemInfo.localIp')">
            Local IP
          </th>
          <th @click="$emit('order', 'name')">Real Name</th>
          <th v-if="licenseEnabled" @click="$emit('order', 'computer.license')">
            Licensed
          </th>
        </tr>
      </thead>
      <TableEffect>
        <tr v-for="computer of items" :key="computer.uid">
          <td>
            <div
              @contextmenu.prevent="
                $emit('menu', { e: $event, computer: computer })
              "
            >
              <router-link
                v-if="!computer.edit"
                :to="
                  `/domains/${$route.params.domainUID}/computers/${computer.uid}/packages`
                "
              >
                <span
                  :data-tooltip="
                    licenseEnabled
                      ? computer.license && !computer.license.active
                        ? 'License is deactivated'
                        : !computer.license
                        ? 'No license'
                        : undefined
                      : false
                  "
                  :class="{
                    'has-text-danger': licenseEnabled && !computer.license,
                    'has-text-warning':
                      licenseEnabled &&
                      computer.license &&
                      !computer.license.active,
                  }"
                >
                  <span class="icon">
                    <i class="mdi mdi-laptop"></i>
                  </span>
                  <span>{{ name(computer) }}</span>
                </span>
              </router-link>
              <EditSingleField
                v-if="computer.edit"
                :text="name(computer)"
                validation="required"
                type="text"
                name="name"
                @save="$emit('save', { computer: computer, text: $event })"
                @cancel="$emit('cancel', computer)"
                :isLoading="computer.saving"
              ></EditSingleField>
            </div>
          </td>
          <td :class="{ 'has-text-success': computer.online }">
            {{ computer.online ? "Yes" : "No" }}
          </td>
          <td>
            <span v-if="computer.onlineChanged">{{
              fromNow(computer.onlineChanged)
            }}</span>
          </td>
          <td :class="{ 'has-text-info': computer.inventorying }">
            {{ computer.inventorying ? "Yes" : "No" }}
          </td>
          <td>{{ computer.clientVersion }}</td>
          <td>
            <span v-if="computer.systemInfo">
              {{ computer.systemInfo.systemDiskType == "SSD" ? "SSD" : "HDD" }}
            </span>
          </td>
          <td>
            <span
              v-if="computer.systemInfo"
              :class="
                ({
                  'has-text-danger':
                    computer.systemInfo.freeSystemDiskSpace < 0.5,
                },
                {
                  'has-text-warning':
                    computer.systemInfo.freeSystemDiskSpace < 7,
                })
              "
              >{{ computer.systemInfo.freeSystemDiskSpace }} GB</span
            >
          </td>
          <td>
            <span v-if="computer.systemInfo && computer.systemInfo.ramTotal"
              >{{ parseAndRound(computer.systemInfo.ramTotal) }} GB</span
            >
          </td>
          <td>
            <span v-if="computer.systemInfo">{{
              computer.systemInfo.osVersion
            }}</span>
          </td>
          <td>
            <span v-if="computer.systemInfo">{{
              computer.systemInfo.localIp
            }}</span>
          </td>
          <td>{{ computer.name }}</td>
          <td v-if="licenseEnabled && computer.license === null">
            No
          </td>
          <td v-if="licenseEnabled && computer.license !== null">
            <span v-if="computer.license">{{
              computer.license.active ? "Yes" : "Not active"
            }}</span>
          </td>
        </tr>
      </TableEffect>
    </table>
  </div>
</template>

<script>
import computerHelper from "@/utils/computer";
import { parseAndRound } from "@/utils/string";
import { fromNow } from "@/utils/date";
export default {
  props: { items: Array },
  components: {
    TableEffect: () => import("@/components/singles/TableEffect.vue"),

    EditSingleField: () =>
      import("@/components/singles/EditSingleField/component.vue"),
  },
  computed: {
    licenseEnabled() {
      return this.$store.state.settings?.server?.licenseEnabled ? true : false;
    },
    parseAndRound() {
      return (str) => {
        return parseAndRound(str);
      };
    },
    name() {
      return (computer) => {
        return computerHelper.getName(computer);
      };
    },
    fromNow() {
      return (date) => {
        return fromNow(date);
      };
    },
  },
};
</script>
